module.exports = {
	"header": "Meet Spotin at DMEXCO",
	"date": "2022/09/09",
	"imgSrc": "DMEXCO_web_news.png",
	"imgAlt": "DMEXCO Conference 2022",
	"ingress": "Spotin is participating in DMEXCO Conference 2022, in Germany (Cologne) on September 21st & 22nd. Spotin enables friction-free commerce from within any 3rd-party website, app or platform - without links or redirections.",
	"sections": [
		{
			"paragraphs": [
				"We are keen to meet investors and VC’s, book’s publishers, content websites/media houses, ecommerce retailers/brands, integration partners, affiliate networks, or any company in publishing or ecommerce that is interested in friction-free commerce. ",
				"If this sounds interesting to you, come, and meet Spotin’s founders and team in hall 06.1 at stand no. T-003, or book a meeting in the events app. In case you are unable to visit us there, feel free to drop an email at <a href='mailto:marketing@spotin.com'>marketing@spotin.com</a> and we will get back to you."
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./pages/news/8/article.json
// module id = 21
// module chunks = 0